// extracted by mini-css-extract-plugin
export default {"link":"AL-z","disabled":"BL-z"};